import createReducer from 'Lib/createReducer';

export const SAVE_HIGHLIGHTS = 'SAVE_HIGHLIGHTS';


const initialState = [{
  id: '',
  markerId: '',
  selectedText: '',
  noteText: '',
  cfi: '',
  color: '',
  lastModifiedAt: ''
}];

const actionHandlers = {
  [SAVE_HIGHLIGHTS]: (state, action) => {
    return [ ...action.data ];
  }
};


export default createReducer(initialState, actionHandlers);
